/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useMemo } from "react";
import Dropdown from "../Dropdown";
import "./auction.css";
import {
  Header,
  CheckBoxList,
} from "./components"; // libraries
import { useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import Labels from "../../services/apiLabels";
import { GET, POST } from "../../constant/apiMethods";
import {
  SET_SELECTED_FILTER,
  PRODUCT_LIST,
  SET_SEARCH_QUERY_FILTER,
  CLEAR_ALL_SELECTED_FILTER,
  BRANDS,
  PRODUCT_LIST_BUY
} from "../../constant/index";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import { API_ENDPOINT } from "../../services/api";
import { getAuthUserId } from "../../services/localStorage";
import { deepSanitizeImageUrls } from "../../utils/sanitizeImageUrl";
import {
  isAuctionFloorPath,
  isBuyNowFloorPath,
} from "../../utils/dealersPath";

function splitFilterValues(value) {
  if (value == null || value === "") return [];
  return String(value)
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
}

function Auctionlist(props) {
  const {
    handleDrawer,
    selectedFilters,
    filtersQuery,
    getProductList,
    getbrands,
    filterData,
    getFilterProduct,
    getBuyNowFilterProduct,
    setPage,
    selectedFilter,
    user_id,
    hideHeader = false,
    onFiltersChanged,
  } = props;
  const { feedback } = useContext(FeedbackContext);
  const history = useHistory();
  const [models, setModels] = useState({});
  const [years, setYears] = useState({});
  const [fuelType, setFuelType] = useState({});
  const [seller, setSeller] = useState([]);
  const [clear, setClear] = useState(Object.keys(selectedFilter?.current).length - 2);
  var auction_page = feedback.auction_page;
  const brands = filterData?.brands?.data?.brands;
  const [selectedFiltersLocal, setFilters] = useState(() => ({
    ...(selectedFilter?.current || {}),
  }));
  const [totalAppliedFilters, setTotalAppliedFilters] = useState(0);
  const location = useLocation();

  const filterValues = (key) => splitFilterValues(selectedFiltersLocal?.[key]);
  const filterCount = (key) => filterValues(key).length;

  useEffect(() => {
    if (hideHeader) return undefined;
    let queryString = Object.keys(selectedFilter.current)
      .map((key) => key + "=" + selectedFilter.current[key])
      .join("&");
    if (isAuctionFloorPath(location.pathname)) {
      getFilterProduct(queryString);
    }
    if (isBuyNowFloorPath(location.pathname)) {
      getBuyNowFilterProduct(queryString);
    }
    return () => {};
  }, []);
  const setTotalAppliedFiltersHandler = () => {
    let array = Object.values(selectedFilters);

    var filtered = array.filter(function (e) {
      return e !== null && e != undefined && e !== "";
    });
    setTotalAppliedFilters(filtered.length);
  };
  const getdata = async (label) => {
    const parameters = {
      GET,
      headers: {
        "Content-Type": "application/json",
      },
    };
    return await fetch(API_ENDPOINT(label), parameters)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        return deepSanitizeImageUrls(json);
      });
  };
  useEffect(() => {
    let cancelled = false;
    (async () => {
      getbrands();
      const sellerData = await getdata(Labels.Seller);
      if (!cancelled) setSeller(sellerData?.data);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  // Re-open applied brand/model cascades so selected options remain visible
  useEffect(() => {
    if (!brands?.length) return undefined;
    let cancelled = false;

    const loadCascade = async () => {
      const selectedBrandNames = splitFilterValues(
        selectedFilter.current.brands
      );
      if (!selectedBrandNames.length) return;

      const nextModels = {};
      await Promise.all(
        selectedBrandNames.map(async (name) => {
          const brand = brands.find((item) => item?.brand_name === name);
          if (!brand?.id) return;
          const data = await getdata(`${Labels.car_models}${brand.id}/`);
          if (Array.isArray(data) && data.length) {
            nextModels[String(brand.id)] = data;
          }
        })
      );
      if (cancelled) return;
      setModels(nextModels);

      const selectedModelNames = splitFilterValues(
        selectedFilter.current.model_name
      );
      const modelItems = Object.values(nextModels).flat();
      const nextFuel = {};
      await Promise.all(
        selectedModelNames.map(async (display) => {
          const model = modelItems.find((item) => item?.display === display);
          if (!model?.value) return;
          const data = await getdata(
            `${Labels.car_fuel_types}${model.value}/`
          );
          if (Array.isArray(data) && data.length) {
            nextFuel[String(model.value)] = data;
          }
        })
      );
      if (cancelled) return;
      setFuelType(nextFuel);

      const selectedFuels = splitFilterValues(selectedFilter.current.fuel_type);
      const fuelItems = Object.values(nextFuel).flat();
      const nextYears = {};
      await Promise.all(
        selectedFuels.map(async (display) => {
          const fuel = fuelItems.find((item) => item?.display === display);
          if (!fuel?.value) return;
          const data = await getdata(`${Labels.car_years}${fuel.value}/`);
          if (Array.isArray(data) && data.length) {
            nextYears[String(fuel.value)] = data;
          }
        })
      );
      if (!cancelled) setYears(nextYears);
    };

    loadCascade();
    return () => {
      cancelled = true;
    };
  }, [brands]);

  const handlefilter = async (type, value, isCheck) => {
    if (type == "millage") {
      if (isCheck) {
        selectedFilter.current["millage"] = value.replace("KM's", "").trim();
      } else {
        delete selectedFilter.current["millage"];
      }
    } else {
      if (isCheck) {
        if (type in selectedFilter.current) {
          let old = selectedFilter.current[type].split(",");
          old.push(value);
          selectedFilter.current[type] = old.toString();
        } else {
          selectedFilter.current[type] = value;
        }
      } else {
        let array = selectedFilter.current[type].split(",");
        const index = array.indexOf(value);
        if (index > -1) {
          // only splice array when item is found
          array.splice(index, 1); // 2nd parameter means remove one item only
        }
        selectedFilter.current[type] = array.toString();
        if (selectedFilter.current[type].length == 0) {
          delete selectedFilter.current[type];
        }
      }
    }
    setFilters({ ...selectedFilter.current });
    setClear(Object.keys(selectedFilter.current).length - 2);
    // Drawer mode: wait for Apply — do not refresh the list yet
    if (hideHeader) {
      selectedFilter.current["page"] = 1;
      return;
    }
    setPage(1);
    selectedFilter.current["page"] = 1;
    let queryString = Object.keys(selectedFilter.current)
      .map((key) => key + "=" + selectedFilter.current[key])
      .join("&");
    if (isAuctionFloorPath(location.pathname)) {
      const filter = await getFilterProduct(queryString);
    }
    if (isBuyNowFloorPath(location.pathname)) {
      const filter = await getBuyNowFilterProduct(queryString);
    }
    onFiltersChanged?.();
  };
  const handleCheckBox = async (id, label, stateData, setData, state) => {
    try {
      if (state) {
        const data = await getdata(`${label}${id}/`);
        if (data.length > 0) {
          stateData[id.toString()] = data;
          setData({ ...stateData });
        }
      } else {
        delete stateData[id.toString()];
        setData({ ...stateData });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getProductListHandler = (query = filtersQuery) => {
    let params = {
      history,
      query,
    };
    getProductList(params);
  };
  useMemo(() => {
    if (hideHeader) return undefined;
    if (selectedFilters) {
      try {
        getProductListHandler();
        setTotalAppliedFiltersHandler();
      } catch (err) {
        console.error("Filter product list failed", err);
      }
    }
    return () => {};
  }, [filtersQuery, selectedFilters]);
  return (
    <div
      className={`position-relative small_scrn_height${
        hideHeader ? " dd-filters-modal__list" : ""
      }`}
      style={{
        margin: "0 auto",
        width: hideHeader ? "100%" : "96%",
      }}
    >
      {!hideHeader ? (
      <Header
        totalAppliedFilters={Object.keys(selectedFilter.current).length - 2}
        clearAll={() => {
          selectedFilter.current = {
            page: 1,
            page_size: 10,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            user_id:user_id
          };
          setFilters({});
          setClear(Object.keys(selectedFilter.current).length - 2);
          // getProductListAll()
          let queryString = Object.keys(selectedFilter.current)
            .map((key) => key + "=" + selectedFilter.current[key])
            .join("&");
          if (isAuctionFloorPath(location.pathname)) {
            getFilterProduct(queryString);
          }
          if (isBuyNowFloorPath(location.pathname)) {
            getBuyNowFilterProduct(queryString);
          }
          onFiltersChanged?.();
        }}
        handleDrawer={handleDrawer}
      />
      ) : (
        <div className="dd-filters-modal__clear-row">
          <button
            type="button"
            className="dd-btn dd-btn--ghost"
            onClick={() => {
              const next = {
                page: 1,
                page_size: selectedFilter.current.page_size || 10,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                user_id,
                sort_cars: selectedFilter.current.sort_cars || "1",
              };
              if (isAuctionFloorPath(location.pathname)) {
                next.auction_status =
                  selectedFilter.current.auction_status ||
                  "Upcoming Auction,Live Auction";
              }
              selectedFilter.current = next;
              setFilters({});
              setClear(0);
              // Drawer mode: Clear only resets the form; Apply refreshes the list
            }}
          >
            Clear all
          </button>
        </div>
      )}
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Drive_Type_title}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("seller_type") > 0}
          activeCount={filterCount("seller_type")}
        >
          <CheckBoxList
            default_value={filterValues("seller_type")}
            handleCheckBox={(id, check, value) =>
              handlefilter("seller_type", value, check)
            }
            data={[
              `${auction_page.Drive_Type_Four_wheel_drive}`,
              `${auction_page.Drive_Type_Front_wheel_drive}`,
            ]}
          />
        </Dropdown>
      </div>
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Doors_Seats_title}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("created_by_name") > 0}
          activeCount={filterCount("created_by_name")}
        >
          {seller?.map((item) => {
            return item.first_name.length > 0 || item.last_name.length > 0 ? (
              <CheckBoxList
                default_value={filterValues("created_by_name")}
                key={item?.id}
                data={[`${item?.first_name} ${item?.last_name}`]}
                to_check={item.username}
                id={item?.id}
                handleCheckBox={(id, check, value) =>
                  handlefilter("created_by_name", item.username, check)
                }
              />
            ) : (
              <CheckBoxList
                default_value={filterValues("created_by_name")}
                key={item?.id}
                data={[`${item?.username}`]}
                to_check={item.username}
                id={item?.id}
                handleCheckBox={(id, check, value) =>
                  handlefilter("created_by_name", item.username, check)
                }
              />
            );
          })}
        </Dropdown>
      </div>
      {isAuctionFloorPath(location.pathname) && (
        <div className="auction_dropdown_wrapper ">
          <Dropdown
            placeholder={auction_page.Auction_Status}
            hideDivider
            maxHeight={true}
            defaultOpen={false}
            activeCount={0}
          >
            <CheckBoxList
              default_value={filterValues("auction_status")}
              handleCheckBox={(id, check, value) =>
                handlefilter("auction_status", value, check)
              }
              data={[
                `${auction_page.Type_Live_Auction}`,
                `${auction_page.Type_Upcoming_Auction}`,
              ]}
            />
          </Dropdown>
        </div>
      )}
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Make_model_title}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("brands") > 0}
          activeCount={filterCount("brands")}
        >
          {brands?.map((item) => {
            return (
              <CheckBoxList
                key={item?.id}
                data={[item?.brand_name]}
                default_value={filterValues("brands")}
                handleCheckBox={(id, check, value) => {
                  handleCheckBox(
                    item.id,
                    Labels.car_models,
                    models,
                    setModels,
                    check
                  );
                  handlefilter("brands", value, check);
                }}
                id={item?.id}
              />
            );
          })}
        </Dropdown>
      </div>
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Model}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("model_name") > 0}
          activeCount={filterCount("model_name")}
        >
          {Object.keys(models)?.map((key, Keyindex) => {
            return models[key].map((item, index) => {
              return (
                <>
                  {
                    <CheckBoxList
                      key={item?.id}
                      data={[item?.display]}
                      default_value={filterValues("model_name")}
                      handleCheckBox={(id, check, value) => {
                        handleCheckBox(
                          item.value,
                          Labels.car_fuel_types,
                          fuelType,
                          setFuelType,
                          check
                        );
                        handlefilter("model_name", value, check);
                      }}
                    />
                  }
                </>
              );
            });
          })}
        </Dropdown>
      </div>
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Price_title}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("fuel_type") > 0}
          activeCount={filterCount("fuel_type")}
        >
          {Object.keys(fuelType)?.map((key, Keyindex) => {
            return fuelType[key].map((item, index) => {
              return (
                <CheckBoxList
                  key={item?.id}
                  data={[item?.display]}
                  default_value={filterValues("fuel_type")}
                  handleCheckBox={(id, check, value) => {
                    handleCheckBox(
                      item.value,
                      Labels.car_years,
                      years,
                      setYears,
                      check
                    );
                    handlefilter("fuel_type", value, check);
                  }}
                />
              );
            });
          })}
        </Dropdown>
      </div>
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Year_title}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("year") > 0}
          activeCount={filterCount("year")}
        >
          {Object.keys(years)?.map((key, Keyindex) => {
            return years[key].map((item, index) => {
              return (
                <CheckBoxList
                  key={item?.id}
                  default_value={filterValues("year")}
                  data={[item?.display]}
                  handleCheckBox={(id, check, value) => {
                    handleCheckBox(
                      item.value,
                      Labels.car_fuel_types,
                      fuelType,
                      setFuelType,
                      check
                    );
                    handlefilter("year", value, check);
                  }}
                />
              );
            });
          })}
        </Dropdown>
      </div>
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Mileage_title}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("millage") > 0}
          activeCount={filterCount("millage")}
        >
          <CheckBoxList
            default_value={filterValues("millage")}
            handleCheckBox={(id, check, value) =>
              handlefilter("millage", value, check)
            }
            data={[
              "1000 KM's",
              "20000 KM's",
              "30000 KM's",
              "40000 KM's",
              "50000 KM's",
              "60000 KM's",
              "70000 KM's",
              "80000 KM's",
              "90000 KM's",
              "100000 KM's",
              "125000 KM's",
              "150000 KM's",
              "200000 KM's",
            ]}
          />
        </Dropdown>
      </div>
      <div className="auction_dropdown_wrapper ">
        <Dropdown
          placeholder={auction_page.Gearbox_Engine_title}
          hideDivider
          maxHeight={true}
          defaultOpen={filterCount("transmission") > 0}
          activeCount={filterCount("transmission")}
        >
          <CheckBoxList
            default_value={filterValues("transmission")}
            data={["Manual", "Automatic"]}
            handleCheckBox={(id, check, value) =>
              handlefilter("transmission", value, check)
            }
          />
        </Dropdown>
      </div>
      <div className={`filter_bar_mobile_footer${hideHeader ? " d-none" : ""}`}>
        <button
          onClick={handleDrawer}
          className="filter_bar_mobile_footer_button "
        >
          {auction_page.Show_Results}
        </button>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  products: state.product,
  filter: state.filters,
  filtersData: state.filters.data,
  selectedFilters: state.filters.selected,
  filtersQuery: state.filters.queryString_,
  filterData: state.showInterest,
  user_id: state.auth.id,
});
const mapDispatchToProps = (dispatch) => ({
  setSelectedFilters: (data) =>
    dispatch({
      type: SET_SELECTED_FILTER,
      payload: data,
    }),
  clearAllSelectedFilters: (data) => {
    dispatch({
      type: CLEAR_ALL_SELECTED_FILTER,
      payload: data,
    });
  },
  setSelectedQueryFilters: (data) =>
    dispatch({
      type: SET_SEARCH_QUERY_FILTER,
      payload: data,
    }),
  // // get product list without filters
  getProductList: (params) =>
    dispatch({
      type: PRODUCT_LIST,
      payload: {
        type: PRODUCT_LIST,
        method: GET,
        label: `${Labels.product_list}?type=${getAuthUserId()}&${params.query}`,
        hideOverlayLoader: true,
        params,
      },
    }),
  // get product list
  getProductListAll: (data) =>
    dispatch({
      type: PRODUCT_LIST,
      payload: {
        type: PRODUCT_LIST,
        method: GET,
        label: Labels.product_list,
        hideOverlayLoader: true,
      },
    }),
  //
  getFilterProduct: (params) =>
    dispatch({
      type: PRODUCT_LIST,
      payload: {
        type: PRODUCT_LIST,
        method: GET,
        label: `${Labels.product_list}?${params}`,
        hideOverlayLoader: true,
        params,
      },
    }),
  getBuyNowFilterProduct: (params) =>
    dispatch({
      type: PRODUCT_LIST_BUY,
      payload: {
        type: PRODUCT_LIST_BUY,
        method: GET,
        label: `${Labels.buynow_list}?${params}`,
        hideOverlayLoader: true,
      },
    } ),
  getbrands: () => {
    return dispatch({
      type: BRANDS,
      payload: {
        type: BRANDS,
        method: POST,
        label: `${Labels.brands}`,
        hideOverlayLoader: true,
      },
    });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(Auctionlist);
